import { merge } from 'lodash';
import * as spcMessages from 'sonata-platform-components/sonataPlatformComponentsCopies';
import * as srcMessages from 'sonata-react-components/sonataReactComponentsCopies';

import { flattenMessages } from './config';
import * as localMessages from './locales/en';

import type { Locale } from './config';

const dictionaries = {
  en: () => {
    const messages = merge({}, srcMessages.en, spcMessages.en, localMessages);

    return flattenMessages(messages);
  }
};

export const getDictionary = (locale: Locale): Record<string, string> => dictionaries[locale]?.() ?? dictionaries.en();
